angular.module('charts').directive('selectAllCheckbox', function () {
    return {
        replace: true,
        restrict: 'E',
        scope: {
            checkboxes: '=',
            label: '=',
            displayCount: '='
        },
        templateUrl: '/resources/charts/partials/select-all-checkbox.html',
        controller: ['$scope', '$element', function ($scope, $element) {

            $scope.selectedBoxes = 0;
            $scope.checkbox = angular.element($element[0].querySelector('.enhanced-checkbox'));

            $scope.masterChange = function () {
                $scope.selectedBoxes = 0;

                if ($scope.master) {
                    angular.forEach($scope.checkboxes, function (cb, index) {
                        if (!cb.disabled && !cb.hidden) {
                            cb.isChecked = true;
                            $scope.selectedBoxes++;
                        }
                    });
                } else {
                    angular.forEach($scope.checkboxes, function (cb, index) {
                        if (!cb.hidden) {
                            cb.isChecked = false;
                        }
                    });
                }
            };

            $scope.$watch('checkboxes', function () {

                var    allSet = true,
                     allClear = true,
                  allDisabled = true,
                        empty,
                  numChecked = 0,
                  numEnabled = 0;
                $scope.selectedBoxes = 0;

                angular.forEach($scope.checkboxes, function (cb, index) {
                    if (cb.isChecked) {
                        allClear = false;
                        $scope.selectedBoxes++;
                        if (!cb.hidden) {
                            numChecked++;
                        }
                    } else {
                        allSet = false;
                    }

                    if(cb.disabled === false) {
                        allDisabled = false;
                        if (!cb.hidden) {
                            numEnabled++;
                        }
                    }
                });

                $element.prop('indeterminate', false);
                $scope.checkbox.prop("indeterminate", false);
                if (allSet) {
                    $scope.master = true;
                    $scope.checkedState = 'checked';
                } else if (allClear) {
                    $scope.master = false;
                    $scope.checkedState = 'unchecked';
                } else {
                    // if there are equal number enabled and selected on screen
                    // we need to deselect on next click
                    if (numChecked === numEnabled) {
                        $scope.master = true;
                    } else {
                        $scope.master = false;
                    }
                    $element.prop('indeterminate', true);
                    $scope.checkbox.prop("indeterminate", true);
                    $scope.checkedState = 'indeterminate';
                }

                empty = $scope.checkboxes.length === 0;
                $scope.disable = empty || allDisabled;

            }, true);
        }]
    };
});
